import { AuthProvider } from "./components/AuthContext";
import { HashRouter, Routes, Route } from "react-router-dom";
import MainPage from "./components/MainPage";
import "./styles/mainFile.css";
import LoginComponent from "./components/LoginComponent";
import RegisterComponent from "./components/RegisterComponent";
import ForgotPassword from "./components/ForgotPassword";
import Dashboard from "./components/Dashboard";
import SignupComponent from "./components/SignupComponent";
import Participans from "./components/Participans";
import LearnMore from "./components/LearnMore";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <HashRouter>
          <Routes>
            <Route exact path="/" element={<MainPage />} />
            <Route path="/login" element={<LoginComponent />} />
            <Route path="/register" element={<RegisterComponent />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/dashboard/signup" element={<SignupComponent />} />
            <Route path="/dashboard/participans" element={<Participans />} />
            <Route path="/dashboard/learn-more" element={<LearnMore />} />
          </Routes>
        </HashRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
